import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import TextField from "components/forms/text-field/text-field";
import TextareaField from "components/forms/textarea-field/textarea-field";
import Form from "components/forms/form/form";


export default function NewApplicationRole() {
    const { t } = useL10n<ILocaleStrings>();
    const navigate = useNavigate();

    const schema = yup.object().shape({ //<IApplicationRole>
        name: yup
            .string()
            .min(2, t("ppaValidationMinLengthMessage", { field: t("name") }))
            .max(64, t("ppaValidationMaxLengthMessage", { field: t("name") }))
            .required(t("ppaValidationRequiredMessage", { field: t("name") })),
        description: yup
            .string()
            .max(256, t("ppaValidationMaxLengthMessage", { field: t("description") }))
            .optional()
    });

    const onSuccess = () => {
        navigate("/settings/permissions/application-roles");
    }

    const onCancel = () => {
        navigate("/settings/permissions/application-roles");
    }

    return (
        <Form
            schema={schema}
            apiUrl="/api/settings/permissions/application-roles"
            method="POST"
            onSuccess={onSuccess}
            onCancel={onCancel}
            submitLabel="save"
            submittingLabel="saving"
            cancelLabel="cancel">
            <TextField
                label="name"
                fieldName="name"
                required />
            <TextareaField
                label="description"
                fieldName="description"
                rows={3} />
        </Form>
    );
}